import { IDispatcherService, IDispatcher } from '../';
import { TriggerAction } from '../../models';
import { ITriggerActionActionsService } from './triggerActions.actionCreator';

export interface ITriggerActionStoreService {
    getAll: (force?: boolean) => angular.IPromise<TriggerAction[]>;
    addOne: (triggerAction: TriggerAction) => angular.IPromise<TriggerAction>;
    updateOne: (triggerAction: TriggerAction) => angular.IPromise<TriggerAction>;
    deleteOne: (triggerAction: TriggerAction) => angular.IPromise<TriggerAction>;
}

export interface ITriggerActionActionDispatcherService extends IDispatcherService<ITriggerActionStoreService> { }

export class TriggerActionActionDispatcherService implements ITriggerActionActionDispatcherService {
    static serviceId = 'triggerActionActionDispatcherService';

    static $inject = ['triggerActionActionsService'];

    constructor(private _service: ITriggerActionActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITriggerActionStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._service.getAll(force)),
                addOne: (triggerAction: TriggerAction) => dispatch(this._service.addOne(triggerAction)),
                updateOne: (triggerAction: TriggerAction) => dispatch(this._service.updateOne(triggerAction)),
                deleteOne: (triggerAction: TriggerAction) => dispatch(this._service.deleteOne(triggerAction))
            }
        };
    }
}
